import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, CopyButton, Highlight } from '@node-space/ui-components'
import { PaymentLinkActions } from 'components/PaymentLinkActions/PaymentLinkActions'
import { SidePanelHeaderTemplateTwo } from 'components/SidePanel/SidePanelHeaderTemplates/SidePanelHeaderTemplateTwo'
import { PaymentsResponse } from 'types/payments'
import { paymentLinkBuilder } from 'utils/paymentLinkBuilder'
import { getHighlightType, titleCase } from 'utils/utils'

const ICONS_BASE_URL = process.env.ICONS_URL

interface CryptoPaymentsSidePanelHeaderProps {
  cryptoPaymentDetails: PaymentsResponse
}

export const CryptoPaymentsSidePanelHeader = ({
  cryptoPaymentDetails,
}: CryptoPaymentsSidePanelHeaderProps) => {
  const { t } = useTranslation()

  const paymentLink =
    paymentLinkBuilder({
      redirectUrl: cryptoPaymentDetails?.redirectUrl,
      uuid: cryptoPaymentDetails?.uuid,
      paymentType: cryptoPaymentDetails?.type?.toLowerCase(),
    }) || ''

  const headerIconUrls = cryptoPaymentDetails?.displayCurrency?.currency
    ? [`${ICONS_BASE_URL}${cryptoPaymentDetails?.displayCurrency?.currency?.toLowerCase()}.svg`]
    : []

  return (
    <SidePanelHeaderTemplateTwo
      heading={{
        iconUrls: headerIconUrls,
        primaryLabel: cryptoPaymentDetails?.displayCurrency
          ? `${cryptoPaymentDetails.displayCurrency.amount ?? ''} ${cryptoPaymentDetails.displayCurrency.currency ?? ''}`.trim()
          : '',
        secondaryLabel: cryptoPaymentDetails?.merchantDisplayName,
      }}
    >
      <Box>
        <Box flexCol className="pl-10">
          <Box flex gapX={4} className="mb-[6px]">
            <p className="text-foreground-prominent text-body-regular">
              {cryptoPaymentDetails?.uuid}
            </p>
            <CopyButton copyText={cryptoPaymentDetails?.uuid} />
          </Box>
          <Box>
            <Highlight type={getHighlightType(cryptoPaymentDetails?.status?.toUpperCase())}>
              {titleCase(cryptoPaymentDetails?.status)}
            </Highlight>
          </Box>
        </Box>
        <Box className="mt-6">
          <PaymentLinkActions
            link={paymentLink}
            openLinkText={t('openPaymentLink')}
            copyLinkText={t('copyPaymentLink')}
          />
        </Box>
      </Box>
    </SidePanelHeaderTemplateTwo>
  )
}
